export default __webpack_public_path__ + "static/media/system-android.png";